import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import {
  Datagrid,
  DatagridColumn,
  DatagridFormat,
} from '@zipari/shared-ds-util-datagrid';
import { getValue } from '../../../shared/utils/get-value';
import { FormattingService } from '../../../shared/services/formatting.service';
import { DatagridDigitalDataService } from '../datagrid-digital-data.service';

@Component({
  selector: 'datagrid-mobile',
  templateUrl: './datagrid-mobile.component.html',
  styleUrl: './datagrid-mobile.component.scss',
})
export class DatagridMobileComponent {
  @Input() data: object[];
  @Input() isLoading: boolean;
  @Input() hasAnErrorOccurred: boolean;
  @Input() config: Datagrid;
  @Input() rows: object[];
  @Input() dataGridId: string;
  @Input() cellOptions: TemplateRef<any>;
  @Input() loading: TemplateRef<any>;
  @Input() error: TemplateRef<any>;
  @Input() noData: TemplateRef<any>;

  @Output() datagridRowSelected = new EventEmitter<any>();
  formats = DatagridFormat;

  constructor(
    private formattingService: FormattingService,
    public digitalDataGridService: DatagridDigitalDataService,
  ) {}

  get maxVisibleCells() {
    return this.config?.mobileConfiguration?.maxVisibleCells || 1;
  }

  get cardConfig() {
    return this.config?.mobileConfiguration;
  }

  get expandableColumns() {
    return this.config?.mobileConfiguration?.isExpandable
      ? this.config.columns.slice(1, this.maxVisibleCells)
      : this.config.columns.slice(1);
  }

  getFormattedValue(row: object, column: Partial<DatagridColumn>): string {
    const formattedValue = this.formattingService.restructureValueBasedOnFormat(
      getValue(row, column.prop),
      column,
    );

    return formattedValue === 0 ? '0' : formattedValue;
  }

  viewDetail(row, columnProp: string, routeToProp?: string) {
    this.datagridRowSelected.emit({ row, columnProp, routeToProp });
  }

  isActionableColumn(columnFormat): boolean {
    const { DOWNLOAD, ICON, ACTION_ICONS } = this.formats;

    return [DOWNLOAD, ICON, ACTION_ICONS].includes(columnFormat);
  }

  getFormattedToolTipValue(
    row: object,
    column: Partial<DatagridColumn>,
  ): string {
    const formattedValue = this.formattingService.restructureValueBasedOnFormat(
      getValue(row, column.tooltipProp),
      column,
      'TEXT',
    );

    return formattedValue === 0 ? '0' : formattedValue;
  }
}
